<template>
<v-dialog
    v-model="dialog"
    max-width="920"
>
    <v-card>
        <v-card-title>Set {{field_label}}</v-card-title>

        <v-card-text>

            <v-select
                label="Selected Invoices"
                :items="selected"
                v-model="picked"
                multiple
                chips
            />

            <v-select
                :label="select_label"
                :items="choices"
                v-model="set_to"
            />

        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                text
                @click="onCancel"
            >
            Cancel
            </v-btn>

            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
            >
            Set
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>
const _ = require('lodash');
export default {

    data() {
        return {
            field: 'complete',
            dialog: false,
            selected: [],
            picked: [],
            set_to: null,
        }
    },

    methods: {

        showDialog(field, selected)
        {   
            this.field = field;
            this.selected = _.cloneDeep(selected);
            this.picked = this.selected.map((cur) => { return cur.value;});
            this.set_to = true;

            this.dialog = true;
        },

        onOk()
        {
            this.dialog = false;

            if ( this.field == 'complete' )
            {
                this.onOkComplete();
            }

            if ( this.field == 'emailed' )
            {
                this.onOkEmailed();
            }

            if ( this.field == 'received' )
            {
                this.onOkReceived();
            }

            if ( this.field == 'collection' )
            {
                this.onOkCollection();
            }
        },

        onOkComplete()
        {
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'PUT: /api/v1/billing/red-chirp-monthly-invoices/set-complete',
            
                'params' : {
                        'invoice_ids': this.picked,
                        'value': this.set_to,
                    },
            
                'on_success': (data) => {
                        if ( this.set_to )
                            this.$rc.snackbar(''+this.picked.length+' invoice(s) marked as complete');
                        else
                            this.$rc.snackbar(''+this.picked.length+' invoice(s) marked as not-complete');

                        this.$emit('change');
                    },
            
                'on_error': 'Unable to complete API call',
            });
        },

        onOkEmailed()
        {
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'PUT: /api/v1/billing/red-chirp-monthly-invoices/set-emailed',
            
                'params' : {
                        'invoice_ids': this.picked,
                        'value': this.set_to,
                    },
            
                'on_success': (data) => {
                        if ( this.set_to )
                            this.$rc.snackbar(''+this.picked.length+' invoice(s) marked as emailed');
                        else
                            this.$rc.snackbar(''+this.picked.length+' invoice(s) marked as not-emailed');

                        this.$emit('change');
                    },
            
                'on_error': 'Unable to complete API call',
            });
        },

        onOkReceived()
        {
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'PUT: /api/v1/billing/red-chirp-monthly-invoices/set-received',
            
                'params' : {
                        'invoice_ids': this.picked,
                        'value': this.set_to,
                    },
            
                'on_success': (data) => {
                        if ( this.set_to )
                            this.$rc.snackbar(''+this.picked.length+' invoice(s) marked as received');
                        else
                            this.$rc.snackbar(''+this.picked.length+' invoice(s) marked as not-received');

                        this.$emit('change');
                    },
            
                'on_error': 'Unable to complete API call',
            });
        },

        onOkCollection()
        {
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'PUT: /api/v1/billing/red-chirp-monthly-invoices/set-collection-state',
            
                'params' : {
                        'invoice_ids': this.picked,
                        'value': this.set_to,
                    },
            
                'on_success': (data) => {
                        this.$rc.snackbar(''+this.picked.length+' invoice(s) collection state marked as '+this.set_to);
                        
                        this.$emit('change');
                    },
            
                'on_error': 'Unable to complete API call',
            });
        },

        onCancel()
        {
            this.dialog = false;
        },

    },

    computed: {
        field_label() 
        {
            if ( this.field == 'complete' )
            {
                return 'Complete';
            }

            if ( this.field == 'emailed' )
            {
                return 'Emailed';
            }

            if ( this.field == 'received' )
            {
                return 'Payment Received on Invoice in Quickbooks';
            }

            if ( this.field == 'collection' )
            {
                return 'Collection State';
            }

            return 'unknown';
        },

        select_label()
        {
            return 'Set '+this.field_label+" To";
        },

        choices()
        {
            if ( this.field == 'complete' )
            {
                return [
                    { 'text': 'Complete', 'value': true },
                    { 'text': 'Not complete', 'value': false },
                ];
            }

            if ( this.field == 'emailed' )
            {
                return [
                    { 'text': 'Invoice has been emailed', 'value': true },
                    { 'text': 'Invoice has not been emailed', 'value': false },
                ];
            }

            if ( this.field == 'received' )
            {
                return [
                    { 'text': 'Payment has been received on invoice in Quickbooks', 'value': true },
                    { 'text': 'Payment has **not** been received on invoice in Quickbooks', 'value': false },
                ];
            }

            if ( this.field == 'collection' )
            {
                return this.$rc.enumChoices('red_chirp_invoice_collection_state', false);
            }

            return [];

        },
    },
}
</script>

<style lang="scss" scoped>
</style>